/* eslint-disable @typescript-eslint/explicit-function-return-type */
import type {Routes} from "@angular/router";
import {UserAccountType} from "../../models/users/User";
import {hasUserTypes, isLoggedIn} from "../../services/guards/permission-guard";

export const calendarRoutes = [
  {
    path: "calendar",
    canActivate: [
      isLoggedIn,
      hasUserTypes(UserAccountType.Admin, UserAccountType.Bactoforce),
    ],
    loadComponent: () => import("./calendar").then(m => m.Calendar),
    data: {
      isDashboard: false,
    },
  },
] as const satisfies Routes;
